import Vue from 'vue';

let Events = new Vue({
    functional: true,

    methods: {
        listen(name, callback) {
            listen(name, callback);
        },

        event(name, callback) {
            event(name, callback);
        },
    }
});

export function event(name, payload) {
    Events.$emit(name, payload);
}

export function listen(name, callback) {
    Events.$on(name, payload => callback(payload));
}

export default Events;
